export const WPL_TEAM_NAME_TITLE = {
  'Delhi Capitals Women': 'Delhi Women',
  'Gujarat Giants Women': 'Gujarat Women',
  'Mumbai Indians Women': 'Mumbai Women',
  'Royal Challengers Bangalore Women': 'Bangalore Women',
  'UP Warriorz': 'UP Women',
  TBA: 'TBA'
}

export const WPL_TEAM_NAME_ABBR = {
  'DEL-W': 'Delhi Women',
  'GUJ-W': 'Gujarat Women',
  'MI-W': 'Mumbai Women',
  'RCB-W': 'Bangalore Women',
  'UP-W': 'UP Women',
  TBA: 'TBA'
}

export const WPL_TEAM_NAME_WITH_ID = {
  '63ef1222cd0901d13d099d7c': 'Delhi Capitals',
  '63ef1220cd0901d13d099336': 'Gujarat Giants',
  '63ef1221cd0901d13d0994bd': 'Mumbai Indians',
  '63ef1222cd0901d13d099b9c': 'Royal Challengers Bangalore',
  '63ef1224cd0901d13d09a2ff': 'UP Warriorz'
}

// "63ef1222cd0901d13d099d7c" => "Delhi Capitals Women"
// "63ef1220cd0901d13d099336" => "Gujarat Giants Women"
// "63ef1221cd0901d13d0994bd" => "Mumbai Indians Women"
// "63ef1222cd0901d13d099b9c" => "Royal Challengers Bangalore Women"
// "63ef1224cd0901d13d09a2ff" => "UP Warriorz"
